// Encapsulate code in Immediately Invoked Functional Expression
(function() {

  // Invoke strict mode
  "use strict";

  var lang = document.documentElement.lang;

  /**
   * Object of DOM element references for the UI.
   *
   * @object ui
   */
  var ui = {};

  /**
   * Object to handle block related functionality.
   *
   * @object block
   */
  var block = {

    index: 0,
    count: 0,

    /**
     * Method to handle block initialization.
     *
     * @method block.init
     */
    init: function() {

      // Get the element references
      ui.form = dom(".form-wrapper[name='quiz-takethereins']");

      if (!ui.form) {
        return;
      }

      block.results = [];

      ui.data = doms(".form-results-data", ui.form);
      for (var i = 0; i < ui.data.length; i++) {
        var data = ui.data[i].dataset;
        block.results.push({
          title: data.resultTitle,
          description: data.resultDescription,
          link: data.resultLink,
          label: data.resultLabel,
        });
      }

      ui.items = doms(".form-item", ui.form);
      ui.buttons = dom(".form-buttons", ui.form);
      ui.begin = dom(".form-button-begin", ui.form);
      ui.previous = dom(".form-button-previous", ui.form);
      ui.next = dom(".form-button-next", ui.form);
      ui.submit = dom(".form-button-submit", ui.form);

      block.count = ui.items.length;

      // Bind the on submit handler
      ui.form.addEventListener("submit", block.submit);

      // Show / hide the buttons
      ui.begin.classList.remove("form-hidden");
      ui.begin.setAttribute("aria-hidden", "false");
      ui.submit.classList.add("form-hidden");
      ui.buttons.classList.add("form-hidden");

      for (var i = 0; i < ui.items.length; i++) {
        ui.items[i].classList.add("form-hidden");
      }

      ui.begin.onclick = function(event) {
        event.preventDefault();
        ui.begin.classList.add("form-hidden");
        ui.begin.setAttribute("aria-hidden", "true");
        ui.buttons.classList.remove("form-hidden");
        ui.buttons.setAttribute("aria-hidden", "false");
        ui.submit.classList.add("form-hidden");
        ui.submit.setAttribute("aria-hidden", "true");
        ui.next.classList.remove("form-hidden");
        ui.next.setAttribute("aria-hidden", "false");
        ui.previous.setAttribute("aria-hidden", "false");
        dom(".form-fieldset-legend", ui.form).classList.add("form-hidden");
        dom(".form-fieldset-summary", ui.form).classList.add("form-hidden");
        ui.items[0].classList.remove("form-hidden");
      };

      dom("button", ui.previous).onclick = block.previous;
      dom("button", ui.next).onclick = block.next;

      // Bind the handler to the key down event on the document
      document.addEventListener("keydown", block.keydown);

    },

    /**
     * Method to handle on previous button click.
     *
     * @method block.previous
     */
    previous: function(event) {

      event.preventDefault();

      ui.submit.classList.add("form-hidden");
      ui.submit.setAttribute("aria-hidden", "true");
      ui.next.classList.remove("form-hidden");
      ui.next.setAttribute("aria-hidden", "false");

      if (block.index == 0) {
        ui.begin.classList.remove("form-hidden");
        ui.begin.setAttribute("aria-hidden", "false");
        ui.buttons.classList.add("form-hidden");
        ui.buttons.setAttribute("aria-hidden", "true");
        ui.next.setAttribute("aria-hidden", "true");
        ui.previous.setAttribute("aria-hidden", "true");
        dom(".form-fieldset-legend", ui.form).classList.remove("form-hidden");
        dom(".form-fieldset-summary", ui.form).classList.remove("form-hidden");
        ui.items[0].classList.add("form-hidden");
        return;
      }

      ui.items[block.index].classList.add("form-hidden");
      block.index -= 1;
      ui.items[block.index].classList.remove("form-hidden");

    },

    /**
     * Method to handle on next button click.
     *
     * @method block.next
     */
    next: function(event) {

      event.preventDefault();

      var field = dom("input", ui.items[block.index]);
      var describedby = field.getAttribute("aria-describedby");
      var helper = document.getElementById(describedby);

      if (!block.check()) {
        helper.style.opacity = 1;
        return;
      }

      helper.style.opacity = 0;

      if (block.index == block.count - 2) {
        ui.submit.classList.remove("form-hidden");
        ui.submit.setAttribute("aria-hidden", "false");
        ui.next.classList.add("form-hidden");
        ui.next.setAttribute("aria-hidden", "true");
      }

      ui.previous.setAttribute("aria-hidden", "false");

      if (block.index == block.count - 1) {
        return;
      }

      ui.items[block.index].classList.add("form-hidden");
      block.index += 1;
      ui.items[block.index].classList.remove("form-hidden");

    },

    /**
     * Method to handle check fields for selection.
     *
     * @method block.check
     */
    check: function() {

      var fields = doms("input[type='radio']", ui.items[block.index]);

      for (var i = 0; i < fields.length; i++) {
        if (fields[i].checked) {
          return true;
        }
      }

      return false;

    },

    /**
     * Method to handle on form submission.
     *
     * @method block.submit
     */
    submit: function(event) {

      event.preventDefault();

      var score = 0;
      var index = 0;
      var error = false;
      var inputs = [];

      for (var i = 0; i < ui.items.length; i++) {

        var fieldset = ui.items[i];
        var fields = doms("input[type='radio']", fieldset);
        var filled = false;
        var describedby = fields[0].getAttribute("aria-describedby");
        var helper = document.getElementById(describedby);

        for (var ii = 0; ii < fields.length; ii++) {
          var field = fields[ii];
          var value = field.value;
          inputs.push(field);
          if (field.checked) {
            filled = true;
            score += window.parseInt(value, 10);
          }
        }

        helper.style.opacity = filled ? 0 : 1;

        if (!filled) {
          error = true;
        }

      }

      if (error) {
        return;
      }

      if (score >= 1 && score <= 2) {
        index = 1;
      } else if (score >= 3 && score <= 7) {
        index = 2;
      } else if (score >= 8) {
        index = 3;
      }

      var result = block.results[index];
      var container = dom(".form-results", ui.form);

      var html = [
        "<h3>", result.title, "</h3>",
        "<p>", result.description, "</p>",
        "<ul>",
          "<li>",
            '<button class="button button-secondary">',
              // HACK: Get value from DOM
              lang === "fr" ? "Refaire le test" : "Restart",
            "</button>",
          "</li>",
          "<li>",
            '<a href="', result.link, '" class="button" target="_blank" rel="noopener">',
              result.label,
            "</a>",
          "</li>",
        "</ul>",
      ].join("");

      container.classList.add("active");
      container.innerHTML = html;

      var button = dom("button", container);
      button.onclick = function(event) {
        container.classList.remove("active");
        // HACK: Replace with cached text from DOM
        container.innerHTML = "Please complete the form to see the results.";
        for (var i = 0; i < inputs.length; i++) {
          inputs[i].checked = false;
        }
        ui.begin.classList.remove("form-hidden");
        ui.buttons.classList.add("form-hidden");
        dom(".form-fieldset-legend", ui.form).classList.remove("form-hidden");
        dom(".form-fieldset-summary", ui.form).classList.remove("form-hidden");
        ui.items[0].classList.add("form-hidden");
        block.index = 0;
      };

      ui.items[block.index].classList.add("form-hidden");
      ui.buttons.classList.add("form-hidden");

    },

  };

  // Bind the init to the global block init event
  rgc.events.on("rgc.blocks.init", block.init.bind(block));

})();
